import { smb_fetch, getAgsApiUrl } from '@/api/operator/fetch';

/**
 * 拉取服务商list
 */
export const getAgencyList = (data: any = {}) => {
  const url = getAgsApiUrl('agency', 'list');
  return smb_fetch(url, {
    method: 'GET',
    data,
  }, false, false);
};

/**
 * 分发服务商
 */
export const distributeAgency = (data: any = {}) => {
  const url = getAgsApiUrl('v2/lead', 'distribute-agency');
  return smb_fetch(url, {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, false, false);
};
